import { render } from "./UserNewArticlesPage.vue?vue&type=template&id=7bbd6466&scoped=true&ts=true&lang=pug"
import script from "./UserNewArticlesPage.vue?vue&type=script&lang=ts"
export * from "./UserNewArticlesPage.vue?vue&type=script&lang=ts"

import "./UserNewArticlesPage.vue?vue&type=style&index=0&id=7bbd6466&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbd6466"]])

export default __exports__